import React from 'react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Skeleton } from '../ui/skeleton';

interface ViewDialogProps {
  /** Не нужен: цвета берутся из токенов. Оставлен для совместимости. */
  isDark?: boolean;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  isLoading?: boolean;
  children: React.ReactNode;
}

export function ViewDialog({
  isOpen,
  onOpenChange,
  title,
  description,
  isLoading = false,
  children,
}: ViewDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        {isLoading ? (
          <div className="flex flex-col gap-3 py-4" aria-busy="true">
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        ) : (
          children
        )}
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            Закрыть
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

// Helper component for detail sections
interface DetailSectionProps {
  title: string;
  isDark?: boolean;
  cols?: 2 | 3;
  children: React.ReactNode;
}

export function DetailSection({ title, cols = 2, children }: DetailSectionProps) {
  return (
    <div>
      <h3 className="mb-3 font-display text-[15px] font-bold text-text">{title}</h3>
      <div className={cn(
        'grid gap-4',
        cols === 3 ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1 sm:grid-cols-2'
      )}>
        {children}
      </div>
    </div>
  );
}

// Helper component for detail items
interface DetailItemProps {
  label: string;
  isDark?: boolean;
  mono?: boolean;
  breakAll?: boolean;
  children: React.ReactNode;
}

export function DetailItem({ label, mono, breakAll, children }: DetailItemProps) {
  const isTextContent = typeof children === 'string' || typeof children === 'number';

  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs text-text-2">{label}</p>
      {isTextContent ? (
        <p className={cn('text-sm text-text', mono && 'font-mono', breakAll && 'break-all')}>{children}</p>
      ) : children}
    </div>
  );
}
